import { CreateLoanNoteRow } from '@willow/types-iso';

import { makeValidator } from '../../shared/makeValidator';

export const validateCreateLoanNotes = makeValidator({
  FieldParser: CreateLoanNoteRow,
});
